import { Folder, Flows } from "../../../../util/Types/Folder";
import { FolderService } from "../../../../service/FolderService";
import { isFluxbotFlow, isFormFlow } from "../../../../components/Layout/LayoutBeta/utils";

export interface OrganizedItems {
  agents: Flows[];
  fluxbots: Flows[];
}

const extractFlowsFromFolders = (folders: Folder[]): Flows[] => {
  const allFlows: Flows[] = [];

  const processFolder = (folder: Folder) => {
    if (folder.flows && folder.flows.length > 0) {
      allFlows.push(...folder.flows);
    }
    if (folder.folders && folder.folders.length > 0) {
      folder.folders.forEach(processFolder);
    }
  };

  folders.forEach(processFolder);
  return allFlows;
};

export const getAgentsOnly = (
  folders: Folder[],
  flows: Flows[],
): Flows[] => {
  const result: Flows[] = [];
  const seenFlowIds = new Set<string>();

  const allFlowsFromFolders = extractFlowsFromFolders(folders);

  allFlowsFromFolders.forEach((flow) => {
    if (seenFlowIds.has(flow.id)) return;
    seenFlowIds.add(flow.id);

    if (isFluxbotFlow(flow) || isFormFlow(flow)) return;
    result.push(flow);
  });

  (flows || []).forEach((flow) => {
    if (seenFlowIds.has(flow.id)) return;
    seenFlowIds.add(flow.id);

    if (isFluxbotFlow(flow) || isFormFlow(flow)) return;
    result.push(flow);
  });

  return result;
};

export const loadFolderWithSubfolders = async (
  folderRef: any,
): Promise<Folder | null> => {
  try {
    const folderData = await FolderService.getOne(folderRef.id);
    const folder = folderData.data;

    if (folder.folders && folder.folders.length > 0) {
      const subfolders = await Promise.all(
        folder.folders.map((subfolderRef: any) =>
          loadFolderWithSubfolders(subfolderRef),
        ),
      );
      folder.folders = subfolders.filter((f): f is Folder => f !== null);
    }

    return folder;
  } catch (error) {
    console.error("Failed to load folder:", error);
    return null;
  }
};

export const organizeItemsByCategory = (
  folders: Folder[],
  flows: Flows[],
): OrganizedItems => {
  const result: OrganizedItems = {
    agents: [],
    fluxbots: [],
  };

  const seenFlowIds = new Set<string>();

  const allFlowsFromFolders = extractFlowsFromFolders(folders);

  allFlowsFromFolders.forEach((flow) => {
    if (seenFlowIds.has(flow.id)) return;
    seenFlowIds.add(flow.id);

    if (isFluxbotFlow(flow)) {
      result.fluxbots.push(flow);
    } else if (!isFormFlow(flow)) {
      result.agents.push(flow);
    }
  });

  (flows || []).forEach((flow) => {
    if (seenFlowIds.has(flow.id)) return;
    seenFlowIds.add(flow.id);

    if (isFluxbotFlow(flow)) {
      result.fluxbots.push(flow);
    } else if (!isFormFlow(flow)) {
      result.agents.push(flow);
    }
  });

  return result;
};
